const ESCAPE_MAP: Record<string, string> = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' };

export function escapeHtml(value: string): string {
  return value.replace(/[&<>"]/g, (c) => ESCAPE_MAP[c]!);
}

/**
 * One form field's value, as a string.
 *
 * `FormData.get` is typed `string | File | null` — a form containing a file
 * input hands back a `File` for that field. `String(file)` is the text
 * `"[object File]"`, so reaching for `String(data.get(name) ?? '')` turns a
 * mistyped or renamed field into plausible-looking junk instead of failing.
 * Every caller wants a text field, so a `File` is treated as absent.
 */
export function formString(data: FormData, name: string): string {
  const value = data.get(name);
  return typeof value === 'string' ? value : '';
}

/**
 * A loosely-typed value as display text — `''` for anything that is not a
 * scalar.
 *
 * Offline payloads and history rows carry field values as `unknown`. They are
 * scalars in practice, but `String()` on an object renders the literal text
 * `"[object Object]"` into the page, which looks like data rather than like a
 * fault. An empty string lets the caller's own `||` fallback take over.
 */
export function scalarString(value: unknown): string {
  switch (typeof value) {
    case 'string': return value;
    case 'number':
    case 'bigint':
    case 'boolean': return String(value);
    default: return '';
  }
}
